import { render, staticRenderFns } from "./PlacementsPerformanceItemReadOnly.vue?vue&type=template&id=5cb5a08a&scoped=true&"
import script from "./PlacementsPerformanceItemReadOnly.vue?vue&type=script&lang=js&"
export * from "./PlacementsPerformanceItemReadOnly.vue?vue&type=script&lang=js&"
import style0 from "./PlacementsPerformanceItemReadOnly.vue?vue&type=style&index=0&id=5cb5a08a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb5a08a",
  null
  
)

export default component.exports